if (typeof window.Wishlist == 'undefined') {
  window.Wishlist = {
    empty: true,
  };
}

Wishlist.WAIT_MAX_RETRIES = 28;
Wishlist.WAIT_INTERVAL = 250;

if (localStorage.getItem('defaultWishlistId')) {
  Wishlist.currentListId = localStorage.getItem('defaultWishlistId');
}

Wishlist.init = function (swat) {
  Wishlist.swat = swat;

  Wishlist.fetchWishlist();
};

Wishlist.getSelectedList = function () {
  return Wishlist.lists.find(({ lid }) => lid === Wishlist.currentListId) || Wishlist.lists[0];
};

Wishlist.fetchWishlist = function () {
  Wishlist.empty = true;

  Wishlist.swat.fetchLists({
    callbackFn: (lists) => {
      lists = lists.reverse(); //Display lists in order of most recent creation

      Wishlist.lists = lists;

      var has_wishlist = false;

      lists.forEach((list) => {
        if (list.lty != 'sfl') {
          has_wishlist = true;
          return false;
        }
      });

      if (has_wishlist) {
        Wishlist.currentListId = Wishlist.currentListId || Wishlist.lists[0]?.lid;

        if (Wishlist.currentListId != 'saveforlater') {
          if (!Wishlist.lists.find(({ lid }) => lid === Wishlist.currentListId)) {
            Wishlist.currentListId = Wishlist.lists[0]?.lid;

            localStorage.setItem('defaultWishlistId', Wishlist.currentListId);
          }
        }

        Wishlist.lists.forEach((list) => {
          if (list.listcontents.length > 0 && list.lty != 'sfl') {
            Wishlist.empty = false;
            return false;
          }
        });

        Wishlist.loaded = true;

        if (Wishlist.empty) {
          document.querySelectorAll('.wishlist-icon-empty').forEach((node) => {
            node.classList.remove('hidden');
          });

          document
            .querySelectorAll('.wishlist__header-body, .wishlist-icon-full, .wishlist-drawer__login, .wishlist-drawer__discover, .wishlist-drawer__footer')
            .forEach((node) => {
              node.classList.add('hidden');
            });
        } else {
          document.querySelectorAll('.wishlist-icon-empty').forEach((node) => {
            node.classList.add('hidden');
          });

          document
            .querySelectorAll('.wishlist__header-body, .wishlist-icon-full, .wishlist-drawer__login, .wishlist-drawer__discover, .wishlist-drawer__footer')
            .forEach((node) => {
              node.classList.remove('hidden');
            });
        }

        Wishlist.loadButtons();
      } else {
        Wishlist.createList('My Picks').then((list) => {
          localStorage.setItem('defaultWishlistId', list.lid);

          Wishlist.currentListId = list.lid;

          Wishlist.fetchWishlist();
        });
      }
    },
    errorFn: (error) => console.error('Error while fetching all Lists', error),
  });
};

Wishlist.variantInList = function (productId, variantId) {
  var isWishlisted = false;

  if (Wishlist.lists) {
    Wishlist.lists.forEach((list) => {
      list.listcontents.forEach((item) => {
        if (item.empi == productId && item.epi == variantId) {
          isWishlisted = true;
        }
      });
    });
  }

  return isWishlisted;
};

Wishlist.productInList = function (productId) {
  var isWishlisted = false;

  if (Wishlist.lists) {
    Wishlist.lists.forEach((list) => {
      list.listcontents.forEach((item) => {
        if (item.empi == productId) {
          isWishlisted = true;
        }
      });
    });
  }

  return isWishlisted;
};

Wishlist.loadButtons = function () {
  document.querySelectorAll('wishlist-button').forEach((node) => {
    const productId = node.dataset.productId;
    const variantId = node.dataset.variantId;

    if (node.dataset.variantLevel == 'true') {
      if (Wishlist.variantInList(productId, variantId)) {
        node.classList.add('wishlist-button--active');
      } else {
        node.classList.remove('wishlist-button--active');
      }
    } else {
      if (Wishlist.productInList(productId)) {
        node.classList.add('wishlist-button--active');
      } else {
        node.classList.remove('wishlist-button--active');
      }
    }

    node.classList.add('loaded');
  });
};

Wishlist.createList = function (listName) {
  return new Promise((resolve, reject) => {
    const onSuccess = async (list) => {
      Wishlist.currentListId = list.lid;

      Wishlist.reloadElements();

      resolve(list);
    };

    const onError = (error) => {
      console.error('Error while creating a List', error);
      reject(error);
    };

    Wishlist.swat.createList({ lname: listName }, onSuccess, onError);
  });
};

Wishlist.deleteList = function (listId) {
  return new Promise((resolve, reject) => {
    let onSuccess = function (deletedListObj) {
      Wishlist.currentListId = localStorage.getItem('defaultWishlistId');

      Wishlist.reloadElements();

      resolve(deletedListObj);
    };

    let onError = function (error) {
      console.error(`Error while deleting the List, ${listId}`, error);
      reject(error);
    };

    Wishlist.swat.deleteList(listId, onSuccess, onError);
  });
};

Wishlist.addToList = function (product, listId) {
  return new Promise((resolve, reject) => {
    let onSuccess = async function (addedListItem) {
      Wishlist.reloadElements();

      resolve(addedListItem);
    };

    let onError = function (error) {
      console.error('Error while adding product to wishlist', error);
      reject(error);
    };

    if (listId) {
      Wishlist.swat.addToList(listId, product, onSuccess, onError);
    } else {
      Wishlist.swat.addToList(Wishlist.currentListId, product, onSuccess, onError);
    }
  });
};

Wishlist.removeVariantFromAllLists = function (productId, productUrl, variantId) {
  var listIds = Wishlist.lists.map((list) => list.lid);

  var product = {
    epi: variantId,
    empi: productId,
    du: productUrl,
  };

  return new Promise((resolve, reject) => {
    let onSuccess = async function (response) {
      Wishlist.reloadElements();

      resolve(response);
    };

    let onError = function (error) {
      console.error('Error while removing product from wishlists', error);
      reject(error);
    };

    Wishlist.swat.removeProductFromLists(product, listIds, onSuccess, onError);
  });
};

Wishlist.removeProductFromAllLists = function (productId) {
  var products = [];
  var listIds = Wishlist.lists.map((list) => list.lid);

  Wishlist.lists.forEach((list) => {
    list.listcontents.forEach((item) => {
      if (item.empi == productId) {
        products.push({
          epi: item.epi,
          empi: item.empi,
          du: item.du,
        });
      }
    });
  });

  var promises = products.map((product) => {
    new Promise((resolve, reject) => {
      let onSuccess = async function (response) {
        resolve(response);
      };

      let onError = function (error) {
        console.error('Error while removing product from wishlists', error);
        reject(error);
      };

      Wishlist.swat.removeProductFromLists(product, listIds, onSuccess, onError);
    });
  });

  return Promise.all(promises).then(() => {
    setTimeout(() => {
      Wishlist.reloadElements();
    }, 600);
  });
};

Wishlist.removeFromList = function (product, listId) {
  return new Promise((resolve, reject) => {
    let onSuccess = async function (deletedProduct) {
      Wishlist.reloadElements();

      resolve(deletedProduct);
    };

    let onError = function (error) {
      console.error('Error while removing product from wishlist', error);
      reject(error);
    };

    if (listId) {
      Wishlist.swat.deleteFromList(listId, product, onSuccess, onError);
    } else {
      Wishlist.swat.deleteFromList(Wishlist.currentListId, product, onSuccess, onError);
    }
  });
};

Wishlist.updateList = function (listId, listName, setDefault) {
  var config = {
    lid: listId,
    lname: listName,
  };

  if (setDefault) {
    localStorage.setItem('defaultWishlistId', listId);
  }

  return new Promise((resolve, reject) => {
    let onSuccess = function (updatedListObj) {
      Wishlist.reloadElements();

      resolve(updatedListObj);
    };

    let onError = function (error) {
      console.error('Error updating the List', error);
      reject(error);
    };

    Wishlist.swat.updateList(config, onSuccess, onError);
  });
};

Wishlist.generateShareLink = function (listId) {
  if (listId == 'saveforlater') {
    listId = SaveForLater.listId;
  }

  return new Promise((resolve, reject) => {
    let onSuccess = function (shareLink) {
      resolve(shareLink);
    };

    let onError = function (error) {
      console.error('Error while generating the link', error);
      reject(error);
    };

    Wishlist.swat.generateSharedListURL(listId, onSuccess, onError);
  });
};

Wishlist.fetchSharedList = function (config) {
  return new Promise((resolve, reject) => {
    let onSuccess = async function (listContents) {
      resolve(listContents);
    };

    let onError = function (error) {
      console.error('Error while removing product from wishlist', error);
      reject(error);
    };

    Wishlist.swat.fetchListCtx(config, onSuccess, onError);
  });
};

Wishlist.reloadElements = function () {
  Wishlist.loaded = false;
  Wishlist.fetchWishlist();

  const lists = document.querySelector('wishlist-list');
  const drawer = document.querySelector('wishlist-drawer');
  const settings = document.querySelector('wishlist-settings');
  const notification = document.querySelector('wishlist-popup');
  const share = document.querySelector('wishlist-share');

  if (lists) {
    lists.init(false);
  }

  if (drawer) {
    drawer.init();
  }

  if (settings) {
    settings.init();
  }

  if (notification) {
    notification.init();
  }

  if (share) {
    share.init();
  }
};

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(Wishlist.init);

if (!customElements.get('wishlist-new-list')) {
  customElements.define(
    'wishlist-new-list',
    class WishlistNewList extends HTMLElement {
      constructor() {
        super();

        this.productId = this.dataset.productId;
        this.productUrl = this.dataset.productUrl;
        this.productHandle = this.dataset.productHandle;
        this.variantId = this.dataset.variantId;

        this.input = this.querySelector('.form__input');
        this.button = this.querySelector('.wishlist-dialog__continue');

        this.link = this.querySelector('.wishlist-popup__list-name');

        this.lists = document.querySelector('wishlist-list');
        this.drawer = document.querySelector('wishlist-drawer');

        this.button.addEventListener('click', this.createList.bind(this));
      }

      createList(e) {
        const listName = this.input.value.trim();

        if (listName.length > 0) {
          Wishlist.createList(listName).then((list) => {
            if (this.productId) {
              Wishlist.addToList(
                {
                  epi: this.variantId,
                  empi: this.productId,
                  du: this.productUrl,
                },
                list.lid
              ).then(() => {
                fetch(`/products/${this.productHandle}/${listName}?section_id=wishlist-added`)
                  .then((response) => response.text())
                  .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');

                    var popup = html.querySelector('modal-dialog');

                    popup.querySelector('.wishlist-popup__list-name').href = `/pages/wishlist?id=${list.lid}`;

                    if (popup) {
                      document.body.appendChild(popup);
                      setTimeout(() => {
                        popup.show();
                      }, 100);
                    }
                  });
              });
            }

            this.parentElement.hide();
          });
        } else {
          // TODO: Error handling
        }
      }
    }
  );
}

if (!customElements.get('wishlist-list')) {
  customElements.define(
    'wishlist-list',
    class WishlistList extends HTMLElement {
      constructor() {
        super();

        this.container = this.querySelector('.wishlist__lists-container');

        this.settings = document.querySelector('wishlist-settings');
        this.share = document.querySelector('wishlist-share');

        this.emptyContainer = this.querySelector('.wishlist-products__empty');
        this.productContainer = this.querySelector('.wishlist-products__list');
        this.productInfo = this.querySelector('.wishlist-products__info');

        this.actions = this.querySelector('wishlist-action');

        this.listsContainer = this.querySelector('.wishlist__lists');
        this.addlist = this.querySelector('#CustomWishlistAddList');
        this.newListDialog = document.querySelector('#WishlistNewListPopup');

        this.productCount = this.querySelector('#CustomWishlistProductCount');

        this.addEventListener('click', (event) => {
          if (event.target && event.target.classList.contains('wishlist__list-button')) {
            if (!event.target.parentElement.classList.contains('wishlist__list--active')) {
              this.querySelectorAll('.wishlist__list-button').forEach((button) => {
                button.parentElement.classList.remove('wishlist__list--active');
              });

              event.target.parentElement.classList.add('wishlist__list--active');

              if (event.target.dataset.saveForLater) {
                Wishlist.currentListId = 'saveforlater';

                this.fetchProductList('saveforlater');

                // Set the url parameter id to the current list id
                var url = new URL(window.location.href);
                url.searchParams.set('id', 'saveforlater');
                window.history.replaceState({}, '', url);

                var actions = document.querySelector('.wishlist-products__info-actions');

                if (actions) {
                  actions.classList.add('no-settings');
                }
              } else {
                Wishlist.currentListId = event.target.dataset.id;

                this.fetchProductList(event.target.dataset.id);

                // Set the url parameter id to the current list id
                var url = new URL(window.location.href);
                url.searchParams.set('id', event.target.dataset.id);
                window.history.replaceState({}, '', url);

                var actions = document.querySelector('.wishlist-products__info-actions');

                if (actions) {
                  actions.classList.remove('no-settings');
                }
              }
            }
          }

          if (event.target && event.target.classList.contains('wishlist-products__empty-delete')) {
            fetch(`/?section_id=wishlist-delete`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');

                var oldPopup = document.querySelector('wishlist-delete-list');

                if (oldPopup) {
                  oldPopup.parentElement.remove();
                }

                var popup = html.querySelector('modal-dialog');

                if (popup) {
                  document.body.appendChild(popup);
                  setTimeout(() => {
                    popup.show();
                  }, 100);
                }
              });
          }
        });

        if (this.addlist) {
          this.addlist.addEventListener('click', () => {
            this.newListDialog.parentElement.show();
          });
        }

        this.init();
      }

      init(fetchUrlId = true) {
        if (this.isWaitingForWishlist) {
          return;
        }

        this.isWaitingForWishlist = true;

        const isWishlistAndSaveForLaterLoaded = () => Wishlist.loaded && SaveForLater.loaded;
        const onWishlistAndSaveForLaterLoaded = () => {
          this.isWaitingForWishlist = false;

          if (fetchUrlId) {
            var urlParams = new URLSearchParams(window.location.search);
            var listId = urlParams.get('id');
          }

          if (listId) {
            Wishlist.currentListId = listId;
          } else {
            listId = Wishlist.currentListId;
          }

          this.fetchWishlists();
          this.fetchProductList(listId);

          if (Wishlist.currentListId == 'saveforlater') {
            var actions = document.querySelector('.wishlist-products__info-actions');

            if (actions) {
              actions.classList.add('no-settings');
            }
          }

          if (!fetchUrlId && Wishlist.empty) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        };

        ReigningChampTools.waitForExternalApp(isWishlistAndSaveForLaterLoaded, onWishlistAndSaveForLaterLoaded, Wishlist.WAIT_MAX_RETRIES, Wishlist.WAIT_INTERVAL);
      }

      fetchWishlists() {
        this.clear();

        if (SaveForLater && SaveForLater.list.items.length > 0) {
          const button = document.createElement('button');
          button.classList.add('link');
          button.classList.add('link--text');
          button.classList.add('wishlist__list-button');
          button.setAttribute('data-save-for-later', 'true');
          button.innerHTML = window.saveForLaterStrings.title;

          const listItem = document.createElement('li');
          listItem.classList.add('wishlist__list');
          listItem.classList.add('slider__slide');

          listItem.appendChild(button);

          if (Wishlist.currentListId == 'saveforlater') {
            listItem.classList.add('wishlist__list--active');

            this.productCount.textContent = `${SaveForLater.list.items.length} product${SaveForLater.list.items.length == 1 ? '' : 's'}`;
          }

          this.listsContainer.appendChild(listItem);

          this.container.classList.remove('hidden');
        } else {
          Wishlist.currentListId = Wishlist.lists[0]?.lid;
        }

        if (!Wishlist.empty) {
          let currentListId = Wishlist.currentListId;
          let lists = Wishlist.lists;

          lists.forEach((list) => {
            if (list.lty == 'sfl') {
              return;
            }

            const button = document.createElement('button');
            button.classList.add('link');
            button.classList.add('link--text');
            button.classList.add('wishlist__list-button');
            button.dataset.id = list.lid;
            button.innerHTML = list.lname;

            const listItem = document.createElement('li');
            listItem.classList.add('wishlist__list');
            listItem.classList.add('slider__slide');

            if (currentListId == list.lid) {
              listItem.classList.add('wishlist__list--active');

              this.productCount.textContent = `${list.listcontents.length} product${list.listcontents.length == 1 ? '' : 's'}`;
            }

            listItem.appendChild(button);

            this.listsContainer.appendChild(listItem);
          });

          var active = this.listsContainer.querySelector('.wishlist__list--active');

          if (active) {
            active.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
          }

          this.container.classList.remove('hidden');
        } else if (this.listsContainer.childNodes.length == 0) {
          this.container.classList.add('hidden');
        }
      }

      fetchProductList(listId) {
        var listId = listId || Wishlist.currentListId;
        var list = Wishlist.lists.find(({ lid }) => lid === listId);

        if (listId == 'saveforlater') {
          list = SaveForLater.list;
        }

        if (this.settings) {
          this.settings.init();
        }

        if (this.share) {
          this.share.init();
        }

        if (Wishlist.empty) {
          this.productInfo.classList.add('hidden');
        } else {
          this.productInfo.classList.remove('hidden');
        }

        if (list) {
          const contents = list.listcontents || list.items;

          this.productCount.textContent = `${contents.length} product${contents.length == 1 ? '' : 's'}`;

          this.productContainer.innerHTML = '';

          if (contents.length == 0) {
            this.emptyContainer.classList.remove('hidden');
            this.productContainer.classList.add('hidden');
            this.productInfo.classList.add('hidden');

            if (Wishlist.lists.length == 1) {
              var empty = this.querySelector('.wishlist-products__empty-span');

              if (empty) {
                this.querySelector('.wishlist-products__empty-span').classList.add('hidden');
              }
            }
          } else {
            this.emptyContainer.classList.add('hidden');
            this.productContainer.classList.remove('hidden');
            this.productInfo.classList.remove('hidden');

            this.productCache = [];

            contents.forEach((item, index) => {
              fetch(`/products/${item.du.split('/products/')[1]}?variant=${item.epi}&section_id=component_wishlist-card`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const card = html.querySelector('.card');

                  this.productCache.push({
                    id: item.epi,
                    card: card,
                  });

                  if (this.productCache.length == contents.length) {
                    // Sort this.product cache to match list.listcontents
                    this.productCache.sort((a, b) => {
                      return contents.findIndex((item) => item.epi == a.id) - contents.findIndex((item) => item.epi == b.id);
                    });

                    this.productCache.forEach((product) => {
                      this.productContainer.appendChild(product.card);
                    });
                  }

                  //if (card) {
                  //  this.productContainer.appendChild(card);
                  //}
                });
            });
          }
        } else {
          console.error('List not found');
        }
      }

      clear() {
        this.listsContainer.innerHTML = '';
      }
    }
  );
}

if (!customElements.get('wishlist-button')) {
  customElements.define(
    'wishlist-button',
    class WishlistButton extends HTMLElement {
      constructor() {
        super();

        this.variantLevel = this.dataset.variantLevel == 'true';

        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        this.productUrl = this.dataset.productUrl;
        this.productHandle = this.dataset.productHandle;

        this.addButton = this.querySelector('.wishlist-button__button--add');
        this.removeButton = this.querySelector('.wishlist-button__button--remove');

        this.showDropdown = this.dataset.showDropdown === 'true';
        this.dropdown = this.querySelector('.wishlist-button__dropdown');
        this.dropdownButtons = this.querySelectorAll('.wishlist-button__dropdown-button');

        this.slider = this.closest('.slider');

        this.init();

        if (this.removeButton) {
          this.removeButton.addEventListener('click', this.remove.bind(this));
        }

        if (this.addButton) {
          this.addButton.addEventListener('click', this.add.bind(this));
        }

        this.dropdownButtons.forEach((button) => {
          button.addEventListener('click', this.updateVariant.bind(this));
        });

        if (this.showDropdown) {
          window.addEventListener('scroll', () => {
            if (!this.dropdown.classList.contains('hidden')) {
              this.dropdown.classList.add('hidden');
            }
          });

          if (this.slider) {
            this.slider.addEventListener('scroll', () => {
              if (!this.dropdown.classList.contains('hidden')) {
                this.dropdown.classList.add('hidden');
              }
            });
          }
        }
      }

      init() {
        if (Wishlist.productInList(this.productId)) {
          this.classList.add('wishlist-button--active');
        }
      }

      updateVariant(e) {
        this.variantId = e.target.dataset.variantId;

        this.forceAdd();
      }

      forceAdd() {
        if (this.variantId == '') {
          this.addButton.querySelector('span').textContent = window.wishlistStrings.selectVariant;

          setTimeout(() => {
            this.addButton.querySelector('span').textContent = window.wishlistStrings.addToList;
          }, 3000);
        } else {
          this.addButton.classList.add('loader-circle');

          var product = {
            epi: this.variantId,
            empi: this.productId,
            du: this.productUrl,
          };

          Wishlist.addToList(product)
            .then((product) => {
              this.showNotification();

              if (this.showDropdown) {
                this.dropdown.classList.add('hidden');
              }

              this.addButton.classList.remove('loader-circle');
              this.classList.add('wishlist-button--active');
            })
            .catch((error) => {
              this.addButton.classList.remove('loader-circle');
            });
        }
      }

      add() {
        if (this.showDropdown) {
          document.querySelectorAll('.wishlist-button__dropdown').forEach((dropdown) => {
            if (dropdown != this.dropdown) {
              dropdown.classList.add('hidden');
            }
          });

          this.dropdown.classList.toggle('hidden');

          var position = this.dropdown.getBoundingClientRect();

          if (position.left < 12) {
            this.dropdown.style.right = `${position.left - 12}px`;
          } else {
            this.dropdown.style.right = `12px`;
          }
        } else {
          this.forceAdd();
        }
      }

      remove() {
        this.removeButton.classList.add('loader-circle');

        if (this.variantLevel) {
          Wishlist.removeVariantFromAllLists(this.productId, this.productUrl, this.variantId)
            .then(() => {
              this.removeButton.classList.remove('loader-circle');
              this.classList.remove('wishlist-button--active');
            })
            .catch((error) => {
              this.removeButton.classList.remove('loader-circle');
            });
        } else {
          Wishlist.removeProductFromAllLists(this.productId, this.productUrl)
            .then(() => {
              this.removeButton.classList.remove('loader-circle');
              this.classList.remove('wishlist-button--active');
            })
            .catch((error) => {
              this.removeButton.classList.remove('loader-circle');
            });
        }
      }

      showNotification() {
        var oldPopup = document.querySelector('wishlist-popup');

        if (oldPopup) {
          oldPopup.remove();
        }

        fetch(`/products/${this.productHandle}?variant=${this.variantId}&section_id=wishlist-popup`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            var popup = html.querySelector('wishlist-popup');

            if (popup) {
              document.body.appendChild(popup);
              setTimeout(() => {
                popup.show();
              }, 100);
            }
          });
      }
    }
  );
}

if (!customElements.get('wishlist-action')) {
  customElements.define(
    'wishlist-action',
    class WishlistAction extends HTMLElement {
      constructor() {
        super();

        this.shareButton = this.querySelector("[data-type='share']");
        this.settingsButton = this.querySelector("[data-type='settings']");

        this.settingsDrawer = document.querySelector('#WishlistSettings');
        this.shareDialog = document.querySelector('#WishlistSharePopup');

        if (this.settingsDrawer) {
          this.settingsButton.addEventListener('click', this.showSettings.bind(this));
        }

        if (this.shareDialog) {
          this.shareButton.addEventListener('click', this.showShare.bind(this));
        }
      }

      showShare() {
        this.shareDialog.show();
      }

      showSettings() {
        this.settingsDrawer.openMenuDrawer();
      }
    }
  );
}

if (!customElements.get('wishlist-remove')) {
  customElements.define(
    'wishlist-remove',
    class WishlistRemove extends HTMLElement {
      constructor() {
        super();

        this.lists = document.querySelector('wishlist-list');
        this.drawer = document.querySelector('wishlist-drawer');

        this.button = this.querySelector('.wishlist-remove__button');

        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        this.productUrl = this.dataset.productUrl;
        this.productHandle = this.dataset.productHandle;

        this.addEventListener('click', this.delete.bind(this));
      }

      delete() {
        this.button.classList.add('loader-circle');

        var product = {
          epi: this.variantId,
          empi: this.productId,
          du: this.productUrl,
        };

        if (Wishlist.currentListId == 'saveforlater') {
          SaveForLater.removeFromList([product])
            .then(() => {
              this.button.classList.remove('loader-circle');
            })
            .catch((error) => {
              this.button.classList.remove('loader-circle');
            });
        } else {
          Wishlist.removeFromList(product, Wishlist.currentListId)
            .then(() => {
              this.button.classList.remove('loader-circle');
            })
            .catch((error) => {
              this.button.classList.remove('loader-circle');
            });
        }
      }
    }
  );
}

if (!customElements.get('wishlist-popup')) {
  customElements.define(
    'wishlist-popup',
    class WishlistPopup extends HTMLElement {
      constructor() {
        super();

        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        this.productUrl = this.dataset.productUrl;
        this.productHandle = this.dataset.productHandle;

        this.listName = this.querySelector('.wishlist-popup__list-name');

        this.toggleButton = this.querySelector('.wishlist-popup__toggle');

        this.editor = this.querySelector('.wishlist-popup__editor');
        this.editorList = this.querySelector('.wishlist-popup__editor-list');

        this.addlist = this.querySelector('.wishlist-popup__editor-button');
        this.newListDialog = document.querySelector(`#WishlistNewListPopup`);

        this.init();

        this.addEventListener('input', this.interact.bind(this));

        this.addEventListener('mouseenter', this.stopHide.bind(this));
        this.addEventListener('mouseleave', this.startHide.bind(this));

        if (this.toggleButton) {
          this.toggleButton.addEventListener('click', this.toggleEditor.bind(this));
        }

        if (this.addlist) {
          this.addlist.addEventListener('click', () => {
            this.stopHide();
            this.hide();

            if (this.newListDialog) {
              this.newListDialog.parentElement.show();
            } else {
              fetch(`/products/${this.productHandle}?variant=${this.variantId}&section_id=wishlist-new`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');

                  var oldPopup = document.querySelector('wishlist-new-list');

                  if (oldPopup) {
                    oldPopup.parentElement.remove();
                  }

                  var popup = html.querySelector('modal-dialog');

                  if (popup) {
                    document.body.appendChild(popup);
                    setTimeout(() => {
                      popup.show();
                    }, 100);
                  }
                });
            }
          });
        }

        // On clicking outside of the element close it.
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target) && !e.target.classList.contains('wishlist-popup__toggle')) {
            this.hide();
          }
        });
      }

      interact(e) {
        if (e.target.type == 'checkbox') {
          var listId = e.target.value;

          var product = {
            epi: this.variantId,
            empi: this.productId,
            du: this.productUrl,
          };

          if (e.target.checked) {
            Wishlist.addToList(product, listId).then(() => {});
          } else {
            Wishlist.removeFromList(product, listId).then(() => {});
          }
        }
      }

      init() {
        if (this.isWaitingForWishlist) {
          return;
        }

        this.isWaitingForWishlist = true;

        const isWishlistLoaded = () => Wishlist.loaded;
        const onWishlistLoaded = () => {
          this.isWaitingForWishlist = false;

          this.buildPopup();
        };

        ReigningChampTools.waitForExternalApp(isWishlistLoaded, onWishlistLoaded, Wishlist.WAIT_MAX_RETRIES, Wishlist.WAIT_INTERVAL);
      }

      clear() {
        if (this.editorList) {
          this.editorList.innerHTML = '';
        }
      }

      buildPopup() {
        // truncate with ellispis after 25 chracters
        this.listName.textContent = Wishlist.getSelectedList().lname.length > 25 ? Wishlist.getSelectedList().lname.substring(0, 25) + '...' : Wishlist.getSelectedList().lname;
        this.listName.href = `/pages/wishlist?id=${Wishlist.getSelectedList().lid}`;

        if (this.editorList) {
          this.clear();

          let lists = Wishlist.lists;

          lists.forEach((list) => {
            if (list.lty == 'sfl') {
              return;
            }

            const listItem = document.createElement('li');
            listItem.classList.add('wishlist-popup__editor-item');

            const listDiv = document.createElement('div');
            listDiv.classList.add('form__field');
            listDiv.classList.add('form__field--checkbox');

            const listCheckbox = document.createElement('input');
            listCheckbox.type = 'checkbox';
            listCheckbox.value = list.lid;
            listCheckbox.classList.add('form__checkbox');
            listCheckbox.classList.add('visually-hidden');
            listCheckbox.id = `wishlist-popup__editor-item-${list.lid}`;
            listCheckbox.checked = list.listcontents.some((item) => item.epi == this.variantId);

            const listLabel = document.createElement('label');
            listLabel.classList.add('form__label--checkbox');
            listLabel.htmlFor = `wishlist-popup__editor-item-${list.lid}`;

            const listLabelBody = document.createElement('label');
            listLabelBody.classList.add('body');
            listLabelBody.classList.add('form__label');
            listLabelBody.htmlFor = `wishlist-popup__editor-item-${list.lid}`;
            listLabelBody.innerHTML = list.lname.length > 25 ? list.lname.substring(0, 25) + '...' : list.lname;

            listDiv.appendChild(listCheckbox);
            listDiv.appendChild(listLabel);
            listDiv.appendChild(listLabelBody);

            listItem.appendChild(listDiv);

            this.editorList.appendChild(listItem);
          });
        }
      }

      show() {
        this.classList.add('loaded');
        this.startHide();
      }

      stopHide() {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
      }

      startHide() {
        this.timeout = setTimeout(() => {
          this.hide();
        }, 5000);
      }

      hide() {
        this.classList.remove('loaded');
        setTimeout(() => {
          this.remove();
        }, 200);
      }

      toggleEditor() {
        if (this.toggleButton.classList.contains('active')) {
          this.hide();
        } else {
          this.classList.toggle('wishlist-popup--editor');
          this.toggleButton.classList.toggle('active');

          this.stopHide();
        }
      }
    }
  );
}

if (!customElements.get('wishlist-drawer')) {
  customElements.define(
    'wishlist-drawer',
    class WishlistDrawer extends HTMLElement {
      constructor() {
        super();

        this.details = document.querySelector('#Details-wishlist-drawer-container');

        this.init();
      }

      init() {
        if (this.isWaitingForWishlist) {
          return;
        }

        this.isWaitingForWishlist = true;

        const isWishlistLoaded = () => Wishlist.loaded;
        const onWishlistLoaded = () => {
          this.isWaitingForWishlist = false;

          this.buildWishlists();
        };

        ReigningChampTools.waitForExternalApp(isWishlistLoaded, onWishlistLoaded, Wishlist.WAIT_MAX_RETRIES, Wishlist.WAIT_INTERVAL);
      }

      buildWishlists() {
        this.clear();

        if (Wishlist.empty) {
          this.details.setAttribute('href', '/pages/wishlist');

          const listContainer = document.createElement('div');
          listContainer.classList.add('wishlist-drawer__list');
          listContainer.classList.add('wishlist-drawer__list--empty');

          const listItemText = document.createElement('p');
          listItemText.classList.add('body');
          listItemText.classList.add('wishlist-drawer__list-empty');
          listItemText.innerHTML = `${window.wishlistStrings.empty}`;

          listContainer.appendChild(listItemText);

          const continueShopping = document.createElement('a');
          continueShopping.classList.add('link');
          continueShopping.classList.add('link--text');
          continueShopping.classList.add('wishlist-drawer__list-empty');
          continueShopping.href = `${window.wishlistStrings.continueShoppingLink}`;
          continueShopping.innerHTML = `${window.wishlistStrings.continueShopping}`;

          listContainer.appendChild(continueShopping);

          this.appendChild(listContainer);
        } else {
          let lists = Wishlist.lists;

          lists.forEach((list) => {
            if (list.lty == 'sfl') {
              return;
            }

            const listContainer = document.createElement('div');
            listContainer.classList.add('wishlist-drawer__list');

            const listHeader = document.createElement('div');
            listHeader.classList.add('wishlist-drawer__list-header');

            const listTitle = document.createElement('h3');
            listTitle.classList.add('subtitle');
            listTitle.classList.add('subtitle--bold');
            listTitle.innerHTML = list.lname.length > 25 ? list.lname.substring(0, 25) + '...' : list.lname;

            const listButton = document.createElement('a');
            listButton.classList.add('link');
            listButton.classList.add('link--text');
            listButton.href = `/pages/wishlist?id=${list.lid}`;
            listButton.innerHTML = 'View All';

            listHeader.appendChild(listTitle);
            listHeader.appendChild(listButton);

            listContainer.appendChild(listHeader);

            if (list.listcontents.length == 0) {
              const listItemText = document.createElement('p');
              listItemText.classList.add('body');
              listItemText.classList.add('wishlist-drawer__list-empty');
              listItemText.innerHTML = `${window.wishlistStrings.empty}`;

              listContainer.appendChild(listItemText);
            } else {
              const listSlider = document.createElement('slider-component');

              const listItems = document.createElement('ul');
              listItems.classList.add('wishlist-drawer__list-items');
              listItems.classList.add('drawer-slider');
              listItems.classList.add('grid');
              listItems.classList.add('grid--4-col');
              listItems.classList.add('slider');
              listItems.classList.add('slider--desktop');
              listItems.classList.add('slider--mobile');
              listItems.classList.add('grid--peek');

              list.listcontents.forEach((item) => {
                const listItem = document.createElement('li');
                listItem.classList.add('grid__item');
                listItem.classList.add('slider__slide');
                listItem.setAttribute('data-wishlist-id', item.epi);

                const listItemLink = document.createElement('a');
                listItemLink.classList.add('link');
                listItemLink.classList.add('full-unstyled-link');
                listItemLink.href = item.du;

                const listItemMedia = document.createElement('div');
                listItemMedia.classList.add('media');
                listItemMedia.classList.add('media--portrait');

                const listItemImage = document.createElement('img');
                listItemImage.src = item.iu;
                listItemImage.alt = item.name;

                listItemMedia.appendChild(listItemImage);
                listItemLink.appendChild(listItemMedia);
                listItem.appendChild(listItemLink);

                listItems.appendChild(listItem);
              });

              listSlider.appendChild(listItems);
              listContainer.appendChild(listSlider);
            }

            this.appendChild(listContainer);
          });
        }
      }

      clear() {
        this.innerHTML = '';
      }
    }
  );
}

if (!customElements.get('wishlist-settings')) {
  customElements.define(
    'wishlist-settings',
    class WishlistSettings extends HTMLElement {
      constructor() {
        super();

        this.container = document.querySelector('#WishlistSettings');

        this.name = this.querySelector('#WishlistSettingsName');
        this.checkbox = this.querySelector('#WishlistSettingsDefault');

        this.saveButton = this.querySelector('.wishlist-settings__save');
        this.deleteButton = this.querySelector('.wishlist-settings__delete');

        this.saveButton.addEventListener('click', this.save.bind(this));
        this.deleteButton.addEventListener('click', this.delete.bind(this));

        this.init();
      }

      init() {
        if (this.isWaitingForWishlist) {
          return;
        }

        this.isWaitingForWishlist = true;

        const isWishlistLoaded = () => Wishlist.loaded;
        const onWishlistLoaded = () => {
          this.isWaitingForWishlist = false;

          this.buildSettings();
        };

        ReigningChampTools.waitForExternalApp(isWishlistLoaded, onWishlistLoaded, Wishlist.WAIT_MAX_RETRIES, Wishlist.WAIT_INTERVAL);
      }

      buildSettings() {
        this.name.value = Wishlist.getSelectedList().lname > 25 ? Wishlist.getSelectedList().lname.substring(0, 25) + '...' : Wishlist.getSelectedList().lname;

        if (localStorage.getItem('defaultWishlistId') == Wishlist.currentListId) {
          this.checkbox.checked = true;
        } else {
          this.checkbox.checked = false;
        }
      }

      delete() {
        fetch(`/?section_id=wishlist-delete`)
          .then((response) => response.text())
          .then((responseText) => {
            this.container.close();

            const html = new DOMParser().parseFromString(responseText, 'text/html');

            var oldPopup = document.querySelector('wishlist-delete-list');

            if (oldPopup) {
              oldPopup.parentElement.remove();
            }

            var popup = html.querySelector('modal-dialog');

            if (popup) {
              document.body.appendChild(popup);
              setTimeout(() => {
                popup.show();
              }, 100);
            }
          });
      }

      save() {
        this.saveButton.classList.add('loader-circle');
        this.saveButton.classList.add('loader-circle--button');

        Wishlist.updateList(Wishlist.currentListId, this.name.value, this.checkbox.checked)
          .then(() => {
            this.container.close();

            this.saveButton.classList.remove('loader-circle');
            this.saveButton.classList.remove('loader-circle--button');
          })
          .catch((error) => {
            this.saveButton.classList.remove('loader-circle');
            this.saveButton.classList.remove('loader-circle--button');
          });
      }
    }
  );
}

if (!customElements.get('wishlist-delete-list')) {
  customElements.define(
    'wishlist-delete-list',
    class WishlistDeleteList extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('.wishlist-dialog__continue');

        this.button.addEventListener('click', this.delete.bind(this));
      }

      setWishlistId(id) {
        this.wishlistId = id;
      }

      delete() {
        var url = new URL(window.location.href);
        url.searchParams.delete('id');
        window.history.replaceState({}, '', url);

        Wishlist.deleteList(Wishlist.currentListId).then(() => {
          this.parentElement.hide();
        });
      }
    }
  );
}

if (!customElements.get('wishlist-share')) {
  customElements.define(
    'wishlist-share',
    class WishlistShare extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('.wishlist-dialog__action');

        this.link = '';

        this.copy = this.querySelector('.wishlist-dialog__action-copy');
        this.copied = this.querySelector('.wishlist-dialog__action-copied');

        this.button.addEventListener('click', this.copyLink.bind(this));

        this.init();
      }

      init() {
        //if (Wishlist.currentListId == 'saveforlater') {
        //  return;
        //}

        if (this.isWaitingForWishlist) {
          return;
        }

        this.isWaitingForWishlist = true;

        const isWishlistLoaded = () => Wishlist.loaded;
        const onWishlistLoaded = () => {
          this.isWaitingForWishlist = false;

          Wishlist.generateShareLink(Wishlist.currentListId).then((link) => {
            this.link = `${window.location.origin}/pages/share-wishlist?id=${Wishlist.currentListId == 'saveforlater' ? SaveForLater.listId : Wishlist.currentListId}`;
          });
        };

        ReigningChampTools.waitForExternalApp(isWishlistLoaded, onWishlistLoaded, Wishlist.WAIT_MAX_RETRIES, Wishlist.WAIT_INTERVAL);
      }

      copyLink() {
        this.button.classList.add('active');

        navigator.clipboard.writeText(this.link);

        setTimeout(() => {
          this.button.classList.remove('active');
        }, 5000);
      }
    }
  );
}

if (!customElements.get('wishlist-collection')) {
  customElements.define(
    'wishlist-collection',
    class WishlistCollection extends HTMLElement {
      constructor() {
        super();

        this.is_share = this.dataset.share == 'true';
        this.wishlistId = this.dataset.wishlistId;

        this.slider = this.querySelector('.content-slider');
        this.productContainer = this.querySelector(`[role="list"]`);
        this.empty = this.querySelector('.wishlist-products__empty');

        if (this.is_share) {
          this.wishlistId = new URLSearchParams(window.location.search).get('id');
        }

        if (this.wishlistId) {
          this.init();
        }
      }

      init() {
        if (this.isWaitingForWishlist) {
          return;
        }

        this.isWaitingForWishlist = true;

        const isWishlistLoaded = () => Wishlist.loaded;
        const onWishlistLoaded = () => {
          this.isWaitingForWishlist = false;

          this.getWishlistCollection();
        };

        ReigningChampTools.waitForExternalApp(isWishlistLoaded, onWishlistLoaded, Wishlist.WAIT_MAX_RETRIES, Wishlist.WAIT_INTERVAL);
      }

      getWishlistCollection() {
        let listConfig = {
          lid: this.wishlistId,
        };

        Wishlist.fetchSharedList(listConfig).then((list) => {
          if (list.length == 0) {
            this.slider.classList.add('hidden');
            this.empty.classList.remove('hidden');
          } else {
            this.slider.classList.remove('hidden');
            this.empty.classList.add('hidden');

            this.productContainer.innerHTML = '';

            this.productCache = [];

            list.forEach((item, index) => {
              fetch(`/products/${item.du.split('/products/')[1]}?variant=${item.epi}&section_id=component_wishlist-card`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const card = html.querySelector('.card');

                  this.productCache.push({
                    id: item.epi,
                    card: card,
                  });

                  if (this.productCache.length == list.length) {
                    this.productCache.sort((a, b) => {
                      return list.findIndex((item) => item.epi == a.id) - list.findIndex((item) => item.epi == b.id);
                    });

                    this.productCache.forEach((product) => {
                      let li = document.createElement('li');
                      const listItem = document.createElement('li');
                      listItem.classList.add('content__item');
                      listItem.classList.add('slider__slide');
                      listItem.classList.add('grid__item');

                      listItem.appendChild(product.card);

                      this.productContainer.appendChild(listItem);
                    });
                  }
                });
            });
          }
        });
      }
    }
  );
}

if (!customElements.get('wishlist-notification')) {
  customElements.define(
    'wishlist-notification',
    class WishlistNotification extends HTMLElement {
      constructor() {
        super();

        this.init();
      }

      init() {
        if (this.isWaitingForWishlist) {
          return;
        }

        this.isWaitingForWishlist = true;

        const isWishlistLoaded = () => Wishlist.loaded;
        const onWishlistLoaded = () => {
          this.isWaitingForWishlist = false;

          this.displayWishlistNotification();
        };

        ReigningChampTools.waitForExternalApp(isWishlistLoaded, onWishlistLoaded, Wishlist.WAIT_MAX_RETRIES, Wishlist.WAIT_INTERVAL);
      }

      displayWishlistNotification() {
        if (Wishlist.empty && localStorage.getItem('wishlistNotification') == null) {
          this.classList.add('loaded');

          localStorage.setItem('wishlistNotification', 'true');

          setTimeout(() => {
            this.remove();
          }, 3000);
        } else {
          this.remove();
        }
      }
    }
  );
}
